/**
 * Utility function to get tooltip text for quote status.
 * Shown when the user hovers over the status in the quote list.
 */
export function getStatusTooltip(status: string): string {
  const statusMap: { [key: string]: string } = {
    New: 'Plans not yet presented to the customer.',
    Quoted: 'A plan was presented to the customer.',
    'Pending Submission': 'The customer wants to enroll. The application is not sent.',
    PendingSubmission: 'The customer wants to enroll. The application is not sent.',
    'Link Sent': 'An e-sign link was sent to the customer.',
    LinkSent: 'An e-sign link was sent to the customer.',
    'Pending Esign': 'Waiting for the customer to complete the e-signature.',
    PendingEsign: 'Waiting for the customer to complete the e-signature.',
    'Enrollment Submitted': 'The application is sent to the carrier.',
    EnrollmentSubmitted: 'The application is sent to the carrier.',
    'Action Needed': 'Needs follow-up due to an issue or missing information.',
    ActionNeeded: 'Needs follow-up due to an issue or missing information.',
    Completed: 'Application was approved, payment received, and coverage is active.',
    Cancelled: 'Application was cancelled by the customer or the carrier.',
  };

  return statusMap[status] ?? '';
}
